namespace Client

open Feliz

type Styles() =
  static member sticky (?top: int, ?zIndex: int) = 
    [ style.position.sticky
      style.top (top |> Option.defaultValue 0)
      style.zIndex (zIndex |> Option.defaultValue 0)
      style.backgroundColor.white ]
  static member stickyTableBorder = style.borderCollapse.separate
  static member bottomBorderWithColor(bottom: int, color: string) =
    [style.borderWidth(0, 0, bottom); style.color(color)]
